import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { BRAND_NAME, BRAND_TAGLINE } from '@/shared/brand'
import { useAuth } from '@/shared/hooks/useAuth'
import { bridge } from '@/shared/bridge'

export function Onboarding() {
  const navigate = useNavigate()
  const { user } = useAuth()

  useEffect(() => {
    if (!user) {
      navigate('/')
      return
    }
  }, [user, navigate])

  return (
    <div className="min-h-screen overflow-y-auto flex flex-col items-center justify-center bg-gradient-to-br from-accent to-pink-500 p-4">
      <div className="text-center max-w-sm w-full">
        <h1 className="text-5xl font-bold text-white mb-4">{BRAND_NAME}</h1>
        <p className="text-xl text-white/80 mb-8">🐾 {BRAND_TAGLINE}</p>

        <div className="bg-white rounded-2xl p-8 shadow-lg">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Добро пожаловать! 👋</h2>

          <div className="space-y-4 text-left">
            <div className="flex items-start space-x-3">
              <span className="text-2xl">🐱</span>
              <p className="text-gray-700">Найди новых знакомых через свайпы</p>
            </div>
            <div className="flex items-start space-x-3">
              <span className="text-2xl">💬</span>
              <p className="text-gray-700">Пиши сообщения в безопасном чате</p>
            </div>
            <div className="flex items-start space-x-3">
              <span className="text-2xl">✨</span>
              <p className="text-gray-700">Создавай свою анкету с фото</p>
            </div>
          </div>

          <button
            onClick={() => {
              bridge.haptic('success')
              navigate('/profile-setup')
            }}
            style={{
              width: '100%',
              marginTop: '24px',
              backgroundColor: '#7c3aed',
              color: '#ffffff',
              border: '2px solid #6d28d9',
              borderRadius: '10px',
              padding: '12px 16px',
              fontWeight: 700,
              fontSize: '16px',
            }}
          >
            Далее →
          </button>

          <p className="text-xs text-gray-500 mt-4">
            Нажимая далее, ты соглашаешься с условиями использования
          </p>
        </div>
      </div>
    </div>
  )
}
